exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-ca819aa6]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:100vh;background:#ff847b;color:#fff}.icon[data-v-ca819aa6]{font-size:45px;margin:5px}.link[data-v-ca819aa6]{text-decoration:underline;cursor:pointer}.row[data-v-ca819aa6]{-ms-flex-pack:center;justify-content:center;text-align:center}div[data-v-ca819aa6]{text-align:center;line-height:25px}div>*[data-v-ca819aa6]{width:100%}", ""]);

// exports
